import styled from "styled-components";
import {brand, fontFamilies, goldEdgeFor} from "../../theme/tokens";

export const ProPill = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 3px;
	background: ${brand.gold};
	color: ${brand.goldInk};
	outline: 1px solid ${({theme}) => goldEdgeFor(theme.tokens)};
	outline-offset: -1px;
	font-family: ${fontFamilies.mono};
	font-weight: 700;
	font-size: 9.5px;
	padding: 2px 5px;
	border-radius: 6px;
	letter-spacing: 0.03em;
	text-transform: uppercase;
`;

export const FreePill = styled.span`
	display: inline-flex;
	align-items: center;
	font-family: ${fontFamilies.mono};
	font-size: 8.5px;
	font-weight: 700;
	letter-spacing: 0.04em;
	padding: 2px 5px;
	border-radius: 6px;
	background: ${({theme}) => theme.tokens.signalTint};
	color: ${({theme}) => theme.tokens.teal};
	text-transform: uppercase;
`;

export const NudgeRoot = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 9px;
	background: ${({theme}) => theme.tokens.goldTint};
	border: 1px solid ${({theme}) => theme.tokens.goldTint};
	border-radius: 11px;
	padding: 9px 11px;
	margin-top: 10px;
	font-size: 12.5px;
	color: ${({theme}) => theme.tokens.ink2};
	line-height: 1.4;

	> span {
		min-width: 0;
		flex: 1 1 210px;
	}

	b {
		color: ${({theme}) => theme.tokens.ink};
		font-weight: 600;
	}
`;

/**
 * The upgrade pill on the gold-tinted strip. Its label is the amber action ink, the pair built for an
 * amber fill: white on the light `orange` (4.67:1) and dark amber on the bright dark-mode one (7.80:1),
 * where white measured 2.11:1 (kitecorp/transferify-ui#3011).
 */
export const UpPill = styled.button`
	margin-inline-start: auto;
	flex: none;
	min-height: 40px;
	background: ${({theme}) => theme.tokens.orange};
	color: ${({theme}) => theme.tokens.amberActionInk};
	border: none;
	font: 700 12px ${fontFamilies.sans};
	padding-inline: 13px;
	border-radius: 9px;
	cursor: pointer;
	transition: filter 160ms ease;

	&:hover {
		filter: brightness(0.92);
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	@media (max-width: 480px) {
		width: 100%;
		min-height: 44px;
	}
`;
